import React from 'react';

const Alert = ({ message, type = 'success' }) => {
  const lightStyles = {
    success: 'bg-green-100 text-green-700',
    error: 'bg-red-100 text-red-700'
  };
  
  const darkStyles = {
    success: 'dark:bg-green-900 dark:text-green-200',
    error: 'dark:bg-red-900 dark:text-red-200'
  };

  return (
    <div className={`${lightStyles[type]} ${darkStyles[type]} px-4 py-3 rounded relative mb-4`} role="alert">
      <span className="block sm:inline">{message}</span>
    </div>
  );
};

export default Alert;